export default "<pagination [totalItems]=\"30\"></pagination>\r\n";